import { call, put, takeLeading } from 'redux-saga/effects'
import * as fromActions from '../../actions/chat.action'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { IChatMessageModel } from 'models/chatMessage.model'
import createMessage from 'api/chat/Create'
import { getMessages, getConversationMessages } from 'api/chat/Get'

async function newMessage(courseId: number, data: IChatMessageModel) {
  return await createMessage(courseId, data)
}

async function handleGetMessages({ courseId, conversationId, identifier = 0 }: any) {
  if (conversationId) return await getConversationMessages(conversationId, identifier)
  return await getMessages(courseId, identifier)
}

function* newMessageEffectSaga(action: any) {
  try {
    const {
      payload: { courseId, userId, message, files, read, conversationId, identifier },
    } = action
    const {
      data: {
        data: { id },
      },
    } = yield call(newMessage, courseId, { userId, message, files, read } as IChatMessageModel)
    yield put(fromActions.Actions.createChatMessageSuccess(id || 0))
    const data = yield call(handleGetMessages, { courseId, conversationId, identifier })
    yield put(fromActions.Actions.getChatMessagesSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.sendMessageError'))
    console.log('error: ', error)
  }
}

export function* newMessageWatcherSaga() {
  yield takeLeading(fromActions.CREATE_CHAT_MESSAGE, newMessageEffectSaga)
}
